/**
 * Complete XION Medical Products Data — aggregator.
 * Category data now lives in ./products/*.js; this file re-exports the named
 * consts and the default object so existing imports keep working.
 */

export { distributor } from './products/distributor';
export { laryngoStroboscopyProcessors, surgeryProcessors, officeMobileProcessors } from './products/cameraProcessors';
export { cameraHeads } from './products/cameraHeads';
export { flexibleEndoscopes, fibreOpticEndoscopes, rigidEndoscopes } from './products/endoscopes';
export { compactCameras } from './products/compactCameras';
export { illuminationSystems } from './products/illumination';
export { documentationSystems } from './products/documentation';
export { softwareSystems } from './products/software';
export { medicalMonitors } from './products/monitors';
export { endoSTROBESystem, endoOFFICESpectarSystem, endoOFFICEVeezarSystem, endoFLEXSpectarSystem, endoCOMPACTVeezarSystem, endoSURGERYSpectarSystem, endoSURGERY3DSpectarSystem, endoPORTABLEVeezarSystem, endoscopyTowerSystem } from './products/systems';

import { distributor } from './products/distributor';
import { laryngoStroboscopyProcessors, surgeryProcessors, officeMobileProcessors } from './products/cameraProcessors';
import { cameraHeads } from './products/cameraHeads';
import { flexibleEndoscopes, fibreOpticEndoscopes, rigidEndoscopes } from './products/endoscopes';
import { compactCameras } from './products/compactCameras';
import { illuminationSystems } from './products/illumination';
import { documentationSystems } from './products/documentation';
import { softwareSystems } from './products/software';
import { medicalMonitors } from './products/monitors';
import { endoSTROBESystem, endoOFFICESpectarSystem, endoOFFICEVeezarSystem, endoFLEXSpectarSystem, endoCOMPACTVeezarSystem, endoSURGERYSpectarSystem, endoSURGERY3DSpectarSystem, endoPORTABLEVeezarSystem, endoscopyTowerSystem } from './products/systems';

export default {
  distributor,
  laryngoStroboscopyProcessors,
  surgeryProcessors,
  officeMobileProcessors,
  cameraHeads,
  flexibleEndoscopes,
  fibreOpticEndoscopes,
  compactCameras,
  rigidEndoscopes,
  illuminationSystems,
  documentationSystems,
  medicalMonitors,
  softwareSystems,
  endoSTROBESystem,
  endoFLEXSpectarSystem,
  endoCOMPACTVeezarSystem,
  endoOFFICESpectarSystem,
  endoOFFICEVeezarSystem,
  endoSURGERYSpectarSystem,
  endoSURGERY3DSpectarSystem,
  endoPORTABLEVeezarSystem,
  endoscopyTowerSystem,
};
